export const getBehaviour = (t) => {

    return {
        basic: [
            { id: 0, textValue: t('billing.pricing.freeSeats', { count: 25 }) },
            {
                id: 1,
                textValue: t('billing.pricing.workplace', { count: 1 })
            },
            {
                id: 2,
                textValue: t('billing.pricing.perOrg', { amount: '5 GB' })
            },
            {
                id: 3,
                textValue: t('billing.pricing.upToGroups', { count: 10 })
            },
            {
                id: 3.5,
                textValue: t('billing.pricing.unlimited_mixrs')
            },
            {
                id: 4,
                textValue: t('billing.pricing.groupDashboard')
            },
            {
                id: 5,
                textValue: t('billing.pricing.privateMessages')
            }],
        essential: [
            {
                id: 0,
                textValue: t('billing.pricing.numberOfSeats')
            },
            {
                id: 1,
                textValue: t('billing.pricing.workplace', { count: 2 })
            },
            {
                id: 2,
                textValue: t('billing.pricing.perWP', { amount: '10 GB' })
            },
            {
                id: 3,
                textValue: t('billing.pricing.unlimited_groups')
            },
            {
                id: 4,
                textValue: t('billing.pricing.unlimited_mixrs')
            },
            {
                id: 5,
                textValue: t('billing.pricing.groupDashboard')
            },
            {
                id: 6,
                textValue: t('billing.pricing.privateMessages')
            }
        ],
        pro: [
            {
                id: 1,
                textValue: t('billing.pricing.benefitsOfEssentials')
            },
            {
                id: 2,
                textValue: t('billing.pricing.workplace', { count: 5 })
            },
            {
                id: 3,
                textValue: t('billing.pricing.perWP', { amount: '20 GB' })
            },
            {
                id: 4,
                textValue: t('billing.pricing.workplaceDashboard')
            },
            {
                id: 5,
                textValue: t('billing.pricing.widget'),
                yearlyOnly: true
            },
            {
                id: 6,
                textValue: t('billing.pricing.onlineSupport')
            }
        ],
        custom: [
            {
                id: 1,
                textValue: t('billing.pricing.benefitsOfPro')
            },
            {
                id: 2,
                textValue: t('billing.pricing.unlimited_workplaces')
            },
            {
                id: 3,
                textValue: t('billing.pricing.customStoragePerWP')
            },
            {
                id: 4,
                textValue: t('billing.pricing.dashboard&Analytics')
            },
            {
                id: 5,
                textValue: t('billing.pricing.customized_support')
            },
            {
                id: 6,
                textValue: t('billing.pricing.SSO')
            }
        ]
    }
}





